import * as R from 'ramda';
import { ActionType } from '../../core/redux/actionType';
import { AppState } from '../../core/redux/appState';
import { Action } from 'redux';


type RemoveFilterParticipantAction = {
  type: ActionType.RemoveFilterParticipant;
  key:  string;
}


/**
 * Dispatch this action remove a filter participant
 * @param key - the key for the participant to remove
 */
export const removeFilterParticipantAction = (key: string): RemoveFilterParticipantAction => ({
  type: ActionType.RemoveFilterParticipant,
  key:  key,
});


export const removeFilterParticipantReducer = (state: AppState, incomingAction: Action): AppState => {
  if (incomingAction.type !== ActionType.RemoveFilterParticipant) {
    return state;
  }
  
  const action = incomingAction as RemoveFilterParticipantAction;

  return R.dissocPath(['reportRecipientSelectedParticipants', action.key], state);
};
